import { format, isValid, parse } from "date-fns";
// convert to specific date format using date-fns
const handleConvertDate = (inputDate, inputFormat, selectedFormat) => {
  const parsedDate = parse(inputDate, inputFormat, new Date());
  return format(parsedDate, selectedFormat);
};

export const convertDateToSpecifiedDateFormat = (worksheet, object) => {
  const changes = [];

  for (let i = 1; i <= worksheet.rowCount; i++) {
    const cellContent = worksheet.getCell(`${object.inColChr}${i}`).value;

    // Skip if cell is empty or null
    if (!cellContent) continue;

    const inputFormat = object?.inputDateFormat;
    let inputDate = "";

    try {
      // get date part (ddmmyyy)
      // because we are splitting date from time if it is present, some date formats in ISO format which has T in between date and time
      if (cellContent.includes("T")) {
        inputDate = cellContent.trim().split("T")[0];
      } else {
        inputDate = cellContent.trim().split(" ")[0];
      }

      // Check if the cell content is a valid date
      const isValidDate =
        inputDate && isValid(parse(inputDate, inputFormat, new Date()));

      if (isValidDate) {
        const convertedDate = handleConvertDate(
          inputDate,
          inputFormat,
          object.toDateFormat,
        );

        // Only track if conversion actually changed the value
        if (convertedDate && convertedDate !== cellContent) {
          changes.push({
            rowIndex: i,
            cellAddress: `${object.inColChr}${i}`,
            originalValue: cellContent,
            extractedDate: inputDate,
            convertedValue: convertedDate,
            inputFormat: inputFormat,
            outputFormat: object.toDateFormat,
            conversionType: cellContent.includes("T")
              ? "ISO_WITH_TIME"
              : "DATE_WITH_SPACE",
          });

          worksheet.getCell(`${object.inColChr}${i}`).value = convertedDate;
        }
      } else {
        // Track invalid dates that couldn't be converted
        changes.push({
          rowIndex: i,
          cellAddress: `${object.inColChr}${i}`,
          originalValue: cellContent,
          extractedDate: inputDate,
          convertedValue: null,
          inputFormat: inputFormat,
          outputFormat: object.toDateFormat,
          error: "INVALID_DATE",
          conversionType: "FAILED",
        });
      }
    } catch (error) {
      // Track parsing errors
      changes.push({
        rowIndex: i,
        cellAddress: `${object.inColChr}${i}`,
        originalValue: cellContent,
        extractedDate: inputDate,
        convertedValue: null,
        inputFormat: inputFormat,
        outputFormat: object.toDateFormat,
        error: error.message,
        conversionType: "ERROR",
      });
    }
  }

  return changes;
};
